// userService.js
import axios from "axios";
import { baseURL as API_URL } from "../config";

export const createUser = async (userData) => {
  const response = await axios.post(`${API_URL}`, userData);
  return response.data;
};

export const getUserById = async (userId) => {
  try {
    if (!userId) {
      throw new Error("User ID is required");
    }

    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Authentication token not found");
    }

    const response = await axios.get(`${API_URL}users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.data) {
      throw new Error("No data received from server");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw new Error("Failed to fetch user details. Please try again.");
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const token = localStorage.getItem("token");
    
    const response = await axios.put(`${API_URL}users/${userId}`, userData, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`,
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error; // Re-throw to let the component handle it
  }
};

export const SlackApi = async (inquiryData) => {
  try {
    const response = await fetch(`${API_URL}customer-inquiry`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: inquiryData.name,
        email: inquiryData.email,
        company_name: inquiryData.companyName,
        inquiry_type: inquiryData.inquiryType,
        message: inquiryData.message,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error("Failed to Request Demo. Please try again.");
  }
};
